import { PostListQuery } from "./PostListQuery";
import { Link, useLocation } from "react-router-dom";
import Post from "../../components/Post/Post";
import { PostClapQuery } from "./PostClapQuery";
import { getUser } from "../../common/helper";
import { useRef } from "react";
import { queryClient } from "../..";
import { UserClapCount } from "./UserClapQuery";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default function PostList() {
  const { pathname } = useLocation();
  const listInnerRef = useRef();
  const { data, isSuccess, fetchNextPage, hasNextPage } = PostListQuery();
  const { data: userClapCountList = {} } = UserClapCount();
  const { mutate } = PostClapQuery();
  const onClapClick = (feedId) => {
    const userId = getUser();
    const data = {
      feed_id: feedId,
      clap_count: 1,
      user_id: parseInt(userId),
    };
    mutate(data, {
      onSuccess: (result) => {
        queryClient.setQueryData("UserClapCount", (oldData) => {
          oldData[result?.data?.feed_id] = result?.data?.clap_count;
          return oldData;
        });
        queryClient.setQueryData("PostList", (oldData) => {
          oldData.pages.forEach((page, index) => {
            let a = page?.results.findIndex(
              (feed) => feed?.feed_id === result?.data?.feed_id
            );
            if (a >= 0) {
              oldData.pages[index].results[a].total_clap_count =
                result.data.total_clap_count;
            }
          });
          return oldData;
        });
      },
    });
  };
  const getRoute = (feedId) => {
    if (pathname.includes("admin") && cookies.get("authorization")) {
      return `/admin/posts/${feedId}/edit`;
    }
    return `/post/${feedId}`;
  };

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight >= scrollHeight) {
        if (hasNextPage) {
          fetchNextPage();
        }
      }
    }
  };

  return (
    <div
      className="post-list p-4 scroll-smooth no-scrollbar"
      onScroll={onScroll}
      ref={listInnerRef}
    >
      {isSuccess &&
        data?.pages?.map((data) =>
          data?.results?.map((post, index) => (
            <Link to={getRoute(post.feed_id)} key={post.feed_id}>
              <Post
                details={post}
                onClapClick={onClapClick}
                index={index}
                userClapCount={userClapCountList[post.feed_id]}
              ></Post>
            </Link>
          ))
        )}
    </div>
  );
}
